<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <br>
  <mat-card>
    <mat-card-content>

      <ng-container *ngIf="showIframe && evoHtmlBody">
        <div class="asc-container">
          <iframe style="width: 100%; height: 80vh; border: none;" [srcdoc]="evoHtmlBody" #iframe id="asc-result"></iframe>
        </div>
      </ng-container> <!-- iframe-->

      <ng-container *ngIf="watchResult === true">
        <div class="allWrap">
          <!-- Panel azul con logo -->

          <!--Declined -->
          <div class="formWrap animate slideIn">
            <ng-container *ngIf="haveErrors === true; else noErros">
              <img src="assets/img/static/declined.png" alt="Declined Icon">
              <h4>Transaction declined</h4>
              <span class="message-error">Something happen processing your transaction</span><br><br>
            </ng-container>

            <ng-template #noErros>
              <img src="assets/img/static/approved.png" alt="Approved Icon">
              <h4>Transaction approved</h4>
              <span class="message-success"> Your transaction was successfully processed</span><br><br>
            </ng-template>
            <hr>

            <ng-container *ngIf="haveErrors === true">
              {{checkTypeErrors()}}
              <h5 class="error-title">Error(s):</h5>
              <br>
              <ul class="error-detail">
                <ng-container *ngIf="haveArray === true">
                  <li *ngFor="let error of errors">
                    {{error}}
                  </li>
                </ng-container>

                <ng-container *ngIf="haveArray === false">
                  <li style="padding-right: 3em;">
                    {{errors}}
                  </li>
                </ng-container>

              </ul>
              <br>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div style="display: flex; justify-content: center; flex-direction: column; width: 100%; margin: 0 auto; height: 59vh;" *ngIf="showLoader === true || !evoHtmlBody">
        <p style="text-align: center;">Processing transaction</p>
        <mat-spinner style="margin: 0 auto" [diameter]="80"></mat-spinner>
      </div>

    </mat-card-content>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Close Window</button>
</mat-dialog-actions>
